"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var vc_configuration_page_service_1 = require("./vc-configuration-page.service");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var sidenav_1 = require("@angular/material/sidenav");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var forms_1 = require("@angular/forms");
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["NOT_CONNECTED"] = "vc.not_connected";
    ConnectionStatus["ACTIVE"] = "vc.active";
    ConnectionStatus["DISCONNECTED"] = "vc.disconnected";
})(ConnectionStatus = exports.ConnectionStatus || (exports.ConnectionStatus = {}));
var VcConfigurationPageComponent = /** @class */ (function () {
    function VcConfigurationPageComponent(vcConfigurationPageService, localeService, currentLanguageProvider) {
        this.vcConfigurationPageService = vcConfigurationPageService;
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.setupSidebarOpen = true;
        // Private
        this._destroy$ = new Subject_1.Subject();
        this.connectionStatusEnum = ConnectionStatus;
        this.credentials = {
            client_secret: new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map()),
            client_id: new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map())
        };
        this.loginResponse = { code: null, url: null };
    }
    VcConfigurationPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.switchMap(function (language) {
            _this.languageId = language.getId();
            return rxjs_1.Observable.fromPromise(_this.localeService.getLocaleInfo(language.getId()));
        }), operators_1.takeUntil(this._destroy$)).subscribe(function (data) {
            _this.localeInfo = data;
            _this.loadConnectionConfigs();
        });
    };
    VcConfigurationPageComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    VcConfigurationPageComponent.prototype.onConnect = function () {
        var _this = this;
        this.setupSidebarOpen = false;
        this.hasHttpErrors = false;
        this.vcConfigurationPageService.settingAccountCredentials(this.credentials)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (response) {
            _this.loginResponse = response;
            _this.authFailed = false;
            _this.setupSidebarOpen = false;
            // this.setupDrawer.close().then(() => {
            //     // this.setupDrawer.position = 'start';
            //     // this.authorizationDrawer.position = 'end';
            //     this.authFailed = false;
            //     this.setupSidebarOpen = false;
            //     // this.authorizationDrawer.open();
            // });
        }, function (error) {
            _this.hasHttpErrors = true;
        });
    };
    VcConfigurationPageComponent.prototype.onCopy = function (value) {
        navigator['clipboard']['writeText'](value).then(function () {
            console.log('Copied to clipboard');
        });
    };
    VcConfigurationPageComponent.prototype.onValidate = function () {
        var _this = this;
        this.vcConfigurationPageService.checkingAccountAuthentication()
            .subscribe(function (success) {
            if (success) {
                _this.setupDrawer.close().then(function () {
                    _this.cleanup();
                    _this.setupSidebarOpen = true;
                });
            }
        }, function (error) {
            if (error.status === 200) {
                _this.cleanup();
            }
            else {
                _this.authFailed = true;
                _this.authSuccess = false;
            }
        });
    };
    VcConfigurationPageComponent.prototype.onCancelSetup = function () {
        this.hasHttpErrors = false;
        // this.setupDrawer.position = 'end';
        // this.authorizationDrawer.position = 'start';
        this.credentials.client_id = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
        this.credentials.client_secret = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
        this.setupDrawer.close();
    };
    VcConfigurationPageComponent.prototype.onCancelAuthorization = function () {
        // this.authorizationDrawer.close().then(() => {
        //     // this.setupDrawer.position = 'end';
        //     // this.authorizationDrawer.position = 'start';
        //     this.setupSidebarOpen = true;
        //     return this.setupDrawer.open();
        // });
        this.setupSidebarOpen = true;
    };
    VcConfigurationPageComponent.prototype.onCancelAuthSuccess = function () {
        this.cleanup();
        this.setupDrawer.close();
        this.setupSidebarOpen = true;
    };
    VcConfigurationPageComponent.prototype.cleanup = function () {
        this.authFailed = false;
        this.loginResponse.code = null;
        this.loginResponse.url = null;
        this.credentials.client_id = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
        this.credentials.client_secret = new idm_crosscutting_concepts_frontend_1.MultilingualString(new Map());
        this.authSuccess = true;
    };
    VcConfigurationPageComponent.prototype.onSetup = function () {
        this.authSuccess = false;
        this.hasHttpErrors = false;
        // this.setupDrawer.position = 'end';
        // this.authorizationDrawer.position = 'start';
        this.setupSidebarOpen = true;
        this.setupDrawer.open();
    };
    VcConfigurationPageComponent.prototype.onRegenerate = function () {
        var _this = this;
        this.vcConfigurationPageService.settingAccountCredentials(this.credentials)
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (response) {
            _this.authFailed = false;
            _this.loginResponse = response;
        }, function (error) {
            _this.regenerationFailed = true;
        });
    };
    VcConfigurationPageComponent.prototype.onOk = function () {
        var _this = this;
        this.setupDrawer.close().then(function () {
            _this.setupSidebarOpen = true;
            _this.loadConnectionConfigs();
        });
    };
    VcConfigurationPageComponent.prototype.loadConnectionConfigs = function () {
        var _this = this;
        this.vcConfigurationPageService.getChanelInfo().subscribe(function (data) {
            _this.connectionConfigs = data; // todo check type
            if (data.connected) {
                _this.connectionStatus = ConnectionStatus.ACTIVE;
            }
            else {
                _this.connectionStatus = ConnectionStatus.DISCONNECTED;
            }
            _this.isInitialized = true;
            _this.configsLoaded = true;
        }, function (error) {
            _this.connectionStatus = ConnectionStatus.NOT_CONNECTED;
            _this.isInitialized = true;
            _this.configsLoaded = true;
        });
    };
    __decorate([
        core_1.ViewChild('setup'),
        __metadata("design:type", sidenav_1.MatSidenav)
    ], VcConfigurationPageComponent.prototype, "setupDrawer", void 0);
    __decorate([
        core_1.ViewChild('clientSecret'),
        __metadata("design:type", forms_1.FormControl)
    ], VcConfigurationPageComponent.prototype, "clientSecret", void 0);
    VcConfigurationPageComponent = __decorate([
        core_1.Component({
            selector: 'sis-vc-configuration-page',
            template: require('./vc-configuration-page.component.html'),
            styles: [require('./vc-configuration-page.component.css')],
        }),
        __metadata("design:paramtypes", [vc_configuration_page_service_1.VcConfigurationPageService,
            idm_locale_service_client_js_1.LocaleService, idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], VcConfigurationPageComponent);
    return VcConfigurationPageComponent;
}());
exports.VcConfigurationPageComponent = VcConfigurationPageComponent;
//# sourceMappingURL=vc-configuration-page.component.js.map